import { ResponsiveBar } from '@nivo/bar'

import { VoiceAgentAnalysisResultName } from 'src/graphql/types/voiceAgentResult'
import { formatSnakeValue } from 'src/lib/formatters'

const VoiceAgentBarChart = ({ voiceAgentAnalysisResults }) => {
  const barChartData = Object.values(VoiceAgentAnalysisResultName)
    .map((key) => ({
      analysisResult: key,
      [key]: voiceAgentAnalysisResults.filter((result) => result.name === key)
        .length,
    }))
    .sort((a, b) => b[b.analysisResult] - a[a.analysisResult])

  return (
    <div className="flex h-[150px] flex-row items-center justify-between">
      <ResponsiveBar
        data={barChartData}
        keys={Object.values(VoiceAgentAnalysisResultName)}
        indexBy="analysisResult"
        margin={{ bottom: 30 }}
        padding={0.1}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={{ scheme: 'blues' }}
        borderRadius={4}
        borderColor={{
          from: 'color',
          modifiers: [['darker', '1.4']],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          format: (value) => formatSnakeValue(value),
          truncateTickAt: 0,
        }}
        axisLeft={null}
        enableTotals={false}
        enableGridX={false}
        enableGridY={false}
        totalsOffset={9}
        labelSkipWidth={9}
        labelSkipHeight={16}
        labelTextColor={{
          from: 'color',
          modifiers: [['darker', 1.6]],
        }}
        labelOffset={1}
        enableLabel={true}
        label={(d) => String(d.value || '0')}
        tooltip={() => {}}
      />
    </div>
  )
}

export default VoiceAgentBarChart
